import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import {platformBrowser} from "@angular/platform-browser";
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import {FoerdermittelcheckModule} from "./app/foerdermittelcheck/foerdermittelcheck.module";

Sentry.init({
  dsn: "https://0a36c686b25a4fd4af21477b2f15c725@sentry.co2online.de/14",
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'fetch' && breadcrumb.data && breadcrumb.data.url && breadcrumb.data.url.match(/^data/)) {
      return null;
    }
    return breadcrumb;
  },

  enabled: environment.production === true,

  environment: window.location.host.indexOf('-dev') > 0? 'stage' : 'production',

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
Sentry.setTag('page_locale', navigator['browserLanguage'] ?? navigator.language);

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(FoerdermittelcheckModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
